import { render, staticRenderFns } from "./PurchaseListFunc.vue?vue&type=template&id=f7152964&scoped=true"
import script from "./PurchaseListFunc.vue?vue&type=script&lang=js"
export * from "./PurchaseListFunc.vue?vue&type=script&lang=js"
import style0 from "./PurchaseListFunc.vue?vue&type=style&index=0&id=f7152964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7152964",
  null
  
)

export default component.exports